import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArWhatHappensNext } from "@/pages/ar/_ArShared";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const HELP_WITH = [
  "برمجيات مخصصة",
  "منتج SaaS",
  "تطبيق جوال",
  "تخطيط موارد المؤسسات (ERP) / إدارة الموارد البشرية (HRMS)",
  "إدارة علاقات العملاء (CRM)",
  "الحوكمة والامتثال (Meyar)",
  "الذكاء الاصطناعي والأتمتة",
  "الحوسبة السحابية والعمليات التقنية",
  "دعم التطبيقات والصيانة",
  "غير ذلك",
];

const BUSINESS_TYPE = [
  "الخدمات اللوجستية والنقل",
  "التجزئة والتجارة الإلكترونية",
  "الرعاية الصحية",
  "التعليم",
  "الخدمات المصرفية والمالية",
  "القطاع الحكومي",
  "الصناعة والتوزيع",
  "العقارات والمرافق",
  "السيارات",
  "أخرى",
];

const ROLES = ["الرئيس التنفيذي / المالك", "مدير التقنية", "مدير العمليات", "مدير المنتج", "غير ذلك"];

export default function ContactAr() {
  return (
    <div data-testid="contact-ar">
      <Seo title="تواصلوا معنا" description="احجزوا مكالمة مع مهندس، أو أرسلوا طلبكم عبر النموذج — نرد خلال يوم عمل واحد." />
      <ArPageHero
        eyebrow="تواصل"
        h1="لنتحدث عمّا تبنونه"
        sub="طريقتان للبدء: احجزوا مكالمة — ثلاثون دقيقة مع مهندس، لا مندوب مبيعات. أو أرسلوا طلبكم عبر النموذج، ونرد خلال يوم عمل واحد."
        breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "الشركة", to: "/ar/company" }, { label: "تواصل" }]}
      />

      <ArBlock tint="white">
        <form action="/api/contact" method="post" className="grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-2" data-testid="contact-form-ar">
          {[
            { name: "first_name", label: "الاسم الأول" },
            { name: "last_name", label: "الاسم الأخير" },
            { name: "email", label: "البريد الإلكتروني", type: "email" },
            { name: "phone", label: "رقم الهاتف" },
            { name: "company", label: "اسم الشركة" },
            { name: "country", label: "الدولة" },
          ].map((f) => (
            <label key={f.name} className="block text-sm font-semibold text-wafa-deep">
              {f.label}
              <input
                required
                type={f.type || "text"}
                name={f.name}
                data-testid={`contact-${f.name}-ar`}
                className="mt-2 block h-10 w-full rounded-md border border-wafa-deep/15 px-3 text-base font-normal text-wafa-ink focus:border-wafa-primary focus:outline-none focus:ring-2 focus:ring-wafa-primary/30"
              />
            </label>
          ))}
          <label className="block text-sm font-semibold text-wafa-deep sm:col-span-2">
            نوع نشاطك
            <select required name="business_type" data-testid="contact-business_type-ar" className="mt-2 block h-10 w-full rounded-md border border-wafa-deep/15 px-3 text-base font-normal text-wafa-ink focus:border-wafa-primary focus:outline-none focus:ring-2 focus:ring-wafa-primary/30">
              <option value="">اختاروا…</option>
              {BUSINESS_TYPE.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
          </label>
          <label className="block text-sm font-semibold text-wafa-deep sm:col-span-2">
            كيف نساعدك؟
            <select required name="help_with" data-testid="contact-help_with-ar" className="mt-2 block h-10 w-full rounded-md border border-wafa-deep/15 px-3 text-base font-normal text-wafa-ink focus:border-wafa-primary focus:outline-none focus:ring-2 focus:ring-wafa-primary/30">
              <option value="">اختاروا…</option>
              {HELP_WITH.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
          </label>
          <label className="block text-sm font-semibold text-wafa-deep sm:col-span-2">
            دوركم
            <select required name="role" data-testid="contact-role-ar" className="mt-2 block h-10 w-full rounded-md border border-wafa-deep/15 px-3 text-base font-normal text-wafa-ink focus:border-wafa-primary focus:outline-none focus:ring-2 focus:ring-wafa-primary/30">
              <option value="">اختاروا…</option>
              {ROLES.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
          </label>
          <label className="block text-sm font-semibold text-wafa-deep sm:col-span-2">
            رسالتكم
            <textarea name="message" rows={5} data-testid="contact-message-ar" className="mt-2 block w-full rounded-md border border-wafa-deep/15 px-3 py-2 text-base font-normal text-wafa-ink focus:border-wafa-primary focus:outline-none focus:ring-2 focus:ring-wafa-primary/30" />
          </label>
          <div className="sm:col-span-2">
            <button type="submit" data-testid="contact-submit-ar" className="inline-flex items-center gap-1.5 rounded-md bg-wafa-primary px-6 py-3 text-sm font-semibold text-white hover:bg-wafa-deep">
              أرسلوا الطلب
            </button>
          </div>
        </form>
      </ArBlock>

      <ArBlock tint="cream" heading="تواصلوا معنا مباشرة">
        <div className="flex flex-wrap gap-4">
          <a href="mailto:support@wafa.om" className="inline-flex items-center gap-1.5 rounded-md border border-wafa-deep/20 px-5 py-2.5 text-sm font-semibold text-wafa-deep hover:border-wafa-deep">
            support@wafa.om
          </a>
          <WhatsAppButton label="تحدثوا معنا عبر واتساب" className="text-sm" source="contact_page" />
        </div>
        <p className="mt-6 text-sm italic text-wafa-ink/70">
          ساعات العمل: من الأحد إلى الخميس، بتوقيت سلطنة عُمان. عملاء باقة "حرج" يمكنهم التواصل في أي وقت.
        </p>
      </ArBlock>

      <ArWhatHappensNext />
    </div>
  );
}
